module.exports = __webpack_public_path__ + "static/media/adobe-lightroom.1c0d38fd.svg";